/* Manikidz — interactions des sections mk-* */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + parts[1];
    if (format && format.indexOf('{{') > -1) {
      return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
    }
    return amount + ' €';
  }

  /* ---------- En-tête ---------- */
  function initHeaders(scope) {
    (scope || document).querySelectorAll('[data-mk-header]').forEach(function (header) {
      if (header.__mk) return;
      header.__mk = true;
      var burger = header.querySelector('[data-mk-burger]');
      var drawer = header.querySelector('[data-mk-drawer]');
      var lastFocus = null;

      /* Ombre + réduction au défilement (fonctionne aussi quand le thème fait défiler .page-wrapper) */
      var section = header.closest('.shopify-section') || header;
      var host = section.parentElement;
      while (host && getComputedStyle(host).display === 'contents') { section = host; host = host.parentElement; }
      if (host && 'IntersectionObserver' in window) {
        var sentinel = document.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none;';
        host.insertBefore(sentinel, host.firstChild);
        new IntersectionObserver(function (entries) {
          header.classList.toggle('is-scrolled', !entries[0].isIntersecting);
        }).observe(sentinel);
      }

      /* Menus déroulants : clavier, tactile, Échap */
      header.querySelectorAll('[data-mk-sub]').forEach(function (item) {
        var link = item.querySelector('.mk-nav__link');
        function set(open) {
          item.classList.toggle('is-open', open);
          link.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        item.addEventListener('mouseenter', function () { link.setAttribute('aria-expanded', 'true'); });
        item.addEventListener('mouseleave', function () { set(false); });
        link.addEventListener('click', function (e) {
          /* Écran tactile : 1er appui ouvre, 2e appui suit le lien */
          if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) {
            e.preventDefault();
            set(true);
          }
        });
        link.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') { e.preventDefault(); set(true); var f = item.querySelector('.mk-nav__panel a'); if (f) f.focus(); }
        });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { set(false); link.focus(); }
        });
        item.addEventListener('focusout', function () {
          setTimeout(function () { if (!item.contains(document.activeElement)) set(false); }, 0);
        });
      });
      document.addEventListener('click', function (e) {
        header.querySelectorAll('[data-mk-sub].is-open').forEach(function (item) {
          if (!item.contains(e.target)) { item.classList.remove('is-open'); item.querySelector('.mk-nav__link').setAttribute('aria-expanded', 'false'); }
        });
      });

      /* Tiroir mobile */
      if (!burger || !drawer) return;
      function focusables() {
        return Array.prototype.filter.call(
          drawer.querySelectorAll('a[href], button, summary'),
          function (el) { return el.offsetParent !== null; }
        );
      }
      function openDrawer() {
        lastFocus = document.activeElement;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        burger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mk-lock');
        setTimeout(function () { var c = drawer.querySelector('.mk-drawer__close'); if (c) c.focus(); }, 60);
      }
      function closeDrawer() {
        if (!drawer.classList.contains('is-open')) return;
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        burger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('mk-lock');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      burger.addEventListener('click', openDrawer);
      drawer.querySelectorAll('[data-mk-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
      drawer.querySelectorAll('a[href]').forEach(function (a) { a.addEventListener('click', closeDrawer); });
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeDrawer(); return; }
        if (e.key !== 'Tab') return;
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      window.matchMedia('(min-width: 1081px)').addEventListener('change', function (m) { if (m.matches) closeDrawer(); });
    });
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-mk-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  /* ---------- Galerie ---------- */
  function initGalleries(scope) {
    (scope || document).querySelectorAll('[data-mk-gallery]').forEach(function (gallery) {
      if (gallery.__mk) return;
      gallery.__mk = true;
      var slides = gallery.querySelectorAll('.mk-gallery__slide');
      var thumbs = gallery.querySelectorAll('.mk-thumb');
      var counter = gallery.querySelector('[data-mk-count]');
      var total = slides.length;
      var index = 0;

      function go(i) {
        if (!total) return;
        index = (i + total) % total;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === index);
          t.setAttribute('aria-pressed', n === index ? 'true' : 'false');
        });
        if (counter) counter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
      }
      gallery.__mkGo = go;
      gallery.__mkGoToMedia = function (mediaId) {
        slides.forEach(function (s, n) { if (s.getAttribute('data-media-id') === String(mediaId)) go(n); });
      };

      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
      var prev = gallery.querySelector('[data-mk-prev]');
      var next = gallery.querySelector('[data-mk-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });

      var main = gallery.querySelector('.mk-gallery__main');
      var startX = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
          startX = null;
        });
      }
    });
  }

  /* ---------- Tiroir panier (Horizon) ---------- */
  function refreshDrawer(html) {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer || !html) return false;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.cart-drawer__inner');
      var current = drawer.querySelector('.cart-drawer__inner');
      if (fresh && current) {
        current.className = fresh.className;
        current.innerHTML = fresh.innerHTML;
      }
      if (typeof drawer.open === 'function') { drawer.open(); return true; }
      if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
    } catch (err) { console.warn('[manikidz] drawer', err); }
    return false;
  }

  /* ---------- Fiche produit ---------- */
  function initProducts(scope) {
    (scope || document).querySelectorAll('[data-mk-product]').forEach(function (el) {
      if (el.__mk) return;
      el.__mk = true;

      var dataEl = el.querySelector('[data-mk-product-json]');
      var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
      var form = el.querySelector('form.mk-form');
      var idInput = form && form.querySelector('input[name="id"]');
      var qtyInput = el.querySelector('[data-mk-qty]');
      var btn = el.querySelector('[data-mk-atc]');
      var btnLabel = btn && btn.querySelector('[data-mk-atc-label]');
      var errorEl = el.querySelector('[data-mk-error]');
      var sticky = el.querySelector('[data-mk-sticky]');
      var stickyBtn = sticky && sticky.querySelector('button');
      var gallery = el.querySelector('[data-mk-gallery]');
      var labels = {
        add: btn ? btn.getAttribute('data-label-add') : 'Ajouter au panier',
        added: btn ? btn.getAttribute('data-label-added') : 'Ajouté au panier',
        soldout: btn ? btn.getAttribute('data-label-soldout') : 'Épuisé'
      };

      function currentVariant() {
        var id = idInput ? Number(idInput.value) : null;
        return data.variants.filter(function (v) { return v.id === id; })[0] || data.variants[0];
      }

      function renderVariant(v) {
        if (!v) return;
        el.querySelectorAll('[data-mk-price]').forEach(function (p) { p.textContent = money(v.price, data.money_format); });
        el.querySelectorAll('[data-mk-compare]').forEach(function (p) {
          var show = v.compare_at_price && v.compare_at_price > v.price;
          p.textContent = show ? money(v.compare_at_price, data.money_format) : '';
          p.hidden = !show;
        });
        el.querySelectorAll('[data-mk-save]').forEach(function (p) {
          var show = v.compare_at_price && v.compare_at_price > v.price;
          if (show) p.textContent = p.getAttribute('data-template').replace('[pct]', Math.round((1 - v.price / v.compare_at_price) * 100));
          p.hidden = !show;
        });
        [btn, stickyBtn].forEach(function (b) {
          if (!b) return;
          b.disabled = !v.available;
        });
        if (btnLabel) btnLabel.textContent = v.available ? labels.add : labels.soldout;
        if (stickyBtn) stickyBtn.textContent = v.available ? labels.add : labels.soldout;
        if (gallery && v.featured_media && gallery.__mkGoToMedia) gallery.__mkGoToMedia(v.featured_media);
        if (data.update_url) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      el.querySelectorAll('[data-mk-variant]').forEach(function (b) {
        b.addEventListener('click', function () {
          el.querySelectorAll('[data-mk-variant]').forEach(function (o) {
            o.classList.toggle('is-active', o === b);
            o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
          });
          if (idInput) idInput.value = b.getAttribute('data-mk-variant');
          renderVariant(currentVariant());
        });
      });

      el.querySelectorAll('[data-mk-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyInput) return;
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.getAttribute('data-mk-step')));
          qtyInput.value = v;
        });
      });

      function setLoading(state) {
        if (!btn) return;
        btn.classList.toggle('is-loading', state);
        btn.disabled = state;
      }

      function addToCart(e) {
        if (e) e.preventDefault();
        if (!idInput) return;
        if (errorEl) errorEl.classList.remove('is-visible');
        setLoading(true);
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: qty }], sections: 'cart-drawer-section' })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.json.description || res.json.message || 'Erreur');
            return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                setCartCount(cart.item_count);
                var html = res.json.sections && res.json.sections['cart-drawer-section'];
                if (btnLabel) {
                  btnLabel.textContent = labels.added;
                  setTimeout(function () { btnLabel.textContent = labels.add; }, 2200);
                }
                if (data.after_add === 'cart') { window.location.href = root + 'cart'; return; }
                if (!refreshDrawer(html)) window.location.href = root + 'cart';
              });
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.classList.add('is-visible'); }
          })
          .finally(function () {
            setLoading(false);
            var v = currentVariant();
            if (btn && v) btn.disabled = !v.available;
          });
      }

      if (form) form.addEventListener('submit', addToCart);
      if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

      if (sticky && btn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var below = entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', !entry.isIntersecting && below);
          });
        });
        io.observe(btn);
      }

      renderVariant(currentVariant());
    });
  }

  /* ---------- Newsletter : message après envoi ---------- */
  function initAll(scope) {
    initHeaders(scope);
    initGalleries(scope);
    initProducts(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Éditeur de thème : réinitialise une section rechargée */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var gallery = e.target.closest && e.target.closest('[data-mk-gallery]');
    if (gallery && gallery.__mkGo) {
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('.mk-gallery__slide'));
      var i = slides.indexOf(e.target.closest('.mk-gallery__slide'));
      if (i > -1) gallery.__mkGo(i);
    }
  });
})();
